import { render, staticRenderFns } from "./EnglishForm.vue?vue&type=template&id=cf1d64e6&scoped=true&"
import script from "./EnglishForm.vue?vue&type=script&lang=js&"
export * from "./EnglishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d64e6",
  null
  
)

export default component.exports